// extracted by mini-css-extract-plugin
export default {"styleNormaliser":"styles-module__styleNormaliser__a2f668fb2cf1b39a011c"};